var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    headerBackgroundColor: colors.porcelain,
    headerColor: colors.oxford,
    headerPadding: "".concat(spacing.xSmall, " ").concat(spacing.small)
  };
};
export default generateComponentTheme;